import { render } from "./SalaryTable.vue?vue&type=template&id=ad6aa066"
import script from "./SalaryTable.vue?vue&type=script&lang=js"
export * from "./SalaryTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__